import { makeStyles } from "@mui/styles";

export default makeStyles(({ functions, borders, palette, transitions }) => {
  const { pxToRem } = functions;
  const { borderRadius } = borders;
  const { dark, transparent } = palette;

  return {
    nestedContainer: {
      width: "100%",
      marginBottom: pxToRem(4.8),
    },
    nestedItem: {
      background: transparent.main,
      color: dark.main,
      display: "flex",
      alignItems: "center",
      width: "100%",
      padding: 0,
      margin: 0,
      borderRadius: borderRadius.md,
      cursor: "pointer",
      userSelect: "none",
      whiteSpace: "nowrap",
      position: "relative",
      "&:hover": {
        background: transparent.main,
      },
      "& .MuiListItemButton-root": {
        padding: 0,
      },
    },
    nestedCollapse: {
      width: "100%",
      "& .MuiList-root": {
        marginLeft: 0,
        marginTop: pxToRem(4.8),
      },
    },
    expandIcon: {
      position: "absolute",
      right: pxToRem(16),
      top: "50%",
      transform: "translateY(-50%)",
      color: dark.main,
      transition: transitions.create(["transform"], {
        easing: transitions.easing.easeInOut,
        duration: transitions.duration.shorter,
      }),
    },
    expandIconOpen: {
      transform: "translateY(-50%) rotate(180deg)",
    },
    childItem: {
      width: "100%",
      marginBottom: pxToRem(4.8),
      "&:last-child": {
        marginBottom: 0,
      },
    },
  };
});
